const setLabel = ({ label, icon }) => `
    <div class="d-flex flex-column align-center justify-center">
      <i class="v-icon notranslate material-icons theme--light" style="font-size: 36px;">${icon}</i>
      <div class="overline">${label}</div>
    </div>
  `

const BlockManager = [
  {
    block: 'Section',
    types: ['landing', 'email', 'pdf', 'thank_you_page'],
    opts: {
      label: setLabel({ label: 'Section', icon: 'crop_landscape' }),
      category: 'General',
      content: `
        <section>
          <div class="container">
            <div class="row">
              <div class="col"></div>
              <div class="col"></div>
              <div class="col"></div>
            </div>
          </div>
        </section>
      `
    }
  },
  {
    block: 'container',
    types: ['landing', 'email', 'pdf', 'thank_you_page'],
    opts: {
      label: setLabel({ label: 'Container', icon: 'crop_din' }),
      category: 'Grid system',
      content: `
        <div class="container">
          <div class="row">
            <div class="col"></div>
            <div class="col"></div>
            <div class="col"></div>
          </div>
        </div>`
    }
  },
  {
    block: 'row',
    types: ['landing', 'email', 'pdf', 'thank_you_page'],
    opts: {
      label: setLabel({ label: 'Row', icon: 'view_stream' }),
      category: 'Grid system',
      content: `
        <div class="row">
          <div class="col"></div>
          <div class="col"></div>
          <div class="col"></div>
        </div>
      `
    }
  },
  {
    block: 'col',
    types: ['landing', 'email', 'pdf', 'thank_you_page'],
    opts: {
      label: setLabel({ label: 'Column', icon: 'view_column' }),
      category: 'Grid system',
      content: `<div class="col" />`
    }
  },
  {
    block: 'spacer',
    types: ['landing', 'email', 'pdf', 'thank_you_page'],
    opts: {
      label: setLabel({ label: 'Spacer', icon: 'space_bar' }),
      category: 'Grid system',
      content: `<div class="spacer" />`
    }
  },
  {
    block: 'text',
    types: ['landing', 'email', 'pdf', 'thank_you_page'],
    opts: {
      label: setLabel({ label: 'Text', icon: 'title' }),
      category: 'Basic',
      content: `<div>Lorem ipsum dolor sit amet consectetur adipisicing elit. Exercitationem commodi recusandae nemo cumque.</div>`
    }
  },
  {
    block: 'button-link',
    types: ['landing', 'email', 'thank_you_page'],
    opts: {
      label: setLabel({
        label: 'Button link',
        icon: `
          <svg class="gjs-block-svg" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width: 40px;">
            <path class="gjs-block-svg-path" d="M22,9 C22,8.4 21.5,8 20.75,8 L3.25,8 C2.5,8 2,8.4 2,9 L2,15 C2,15.6 2.5,16 3.25,16 L20.75,16 C21.5,16 22,15.6 22,15 L22,9 Z M21,15 L3,15 L3,9 L21,9 L21,15 Z" fill-rule="nonzero"></path>
            <rect class="gjs-block-svg-path" x="4" y="11.5" width="16" height="1"></rect>
          </svg>
        `
      }),
      category: 'Basic',
      content: `<a href="" class="button size--default">
        <span>Button</span
      </a>`
    }
  },
  {
    block: 'block-link',
    types: ['landing', 'email', 'thank_you_page'],
    opts: {
      category: 'Basic',
      label: setLabel({ label: 'Block link', icon: 'link' }),
      content: {
        type: 'link',
        editable: false,
        droppable: true,
        style: {
          display: 'inline-block',
          padding: '5px',
          'min-height': '50px',
          'min-width': '50px'
        }
      }
    }
  },
  {
    block: 'divider',
    types: ['landing', 'email', 'pdf', 'thank_you_page'],
    opts: {
      label: setLabel({ label: 'Divider', icon: 'horizontal_rule' }),
      category: 'Basic',
      content: `<hr class="divider">`
    }
  },
  {
    block: 'image',
    types: ['landing', 'email', 'pdf', 'thank_you_page'],
    opts: {
      label: setLabel({ label: 'Image', icon: 'image' }),
      category: 'Multimedia',
      select: true,
      content: { type: 'image' },
      activate: true
    }
  },
  {
    block: 'video',
    types: ['landing', 'email', 'thank_you_page'],
    opts: {
      label: setLabel({ label: 'Video', icon: 'movie' }),
      category: 'Multimedia',
      content: { type: 'video' }
    }
  },
  {
    block: 'map',
    types: ['landing', 'email', 'thank_you_page'],
    opts: {
      label: setLabel({ label: 'Map', icon: 'map' }),
      category: 'Multimedia',
      content: { type: 'map' }
    }
  },
  {
    block: 'afrus-form',
    types: ['landing'],
    opts: {
      label: setLabel({
        label: 'Afrus form',
        icon: `
          <svg class="gjs-block-svg" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width: 40px;">
            <path class="gjs-block-svg-path" d="M14.8,6.2H9.1c-0.2,0-0.5,0.1-0.6,0.3l-3,5.2c-0.1,0.2-0.1,0.5,0,0.7l3,5.2c0.1,0.2,0.3,0.3,0.6,0.3h5.7
              c0.2,0,0.5-0.1,0.6-0.3l3-5.2c0.1-0.2,0.1-0.5,0-0.7l-3-5.2C15.3,6.3,15.1,6.2,14.8,6.2z M14.3,12.3l-0.9,1.6
              c-0.1,0.2-0.3,0.3-0.6,0.3h-1.7c-0.2,0-0.5-0.1-0.6-0.3l-0.9-1.6c-0.1-0.2-0.1-0.5,0-0.7l0.9-1.6c0.1-0.2,0.3-0.3,0.6-0.3h1.7
              c0.2,0,0.5,0.1,0.6,0.3l0.9,1.6C14.4,11.9,14.4,12.1,14.3,12.3z"/>
            <path class="gjs-block-svg-path" d="M7.2,18l-3.3-5.7c-0.1-0.2-0.1-0.5,0-0.7l2.6-4.5c0.3-0.4-0.1-1-0.6-1H3.7c-0.2,0-0.5,0.1-0.6,0.3l-3,5.2
              c-0.1,0.2-0.1,0.5,0,0.7l4.8,8.3C5.1,21,5.8,21,6,20.6l1.1-1.9C7.3,18.5,7.3,18.2,7.2,18z"/>
            <path class="gjs-block-svg-path" d="M5.3,4.6h2.6l0,0h6.9c0.2,0,0.5-0.1,0.6-0.3l1.1-2c0.3-0.4-0.1-1-0.6-1H6.5C6.2,1.3,6,1.4,5.9,1.6l-1.1,2
              C4.5,4.1,4.8,4.6,5.3,4.6z"/>
            <path class="gjs-block-svg-path" d="M13.1,19.4H8.9c-0.2,0-0.5,0.1-0.6,0.3l-1.1,2c-0.3,0.4,0.1,1,0.6,1H12c0.2,0,0.5-0.1,0.6-0.3l1.1-2
              C14,19.9,13.6,19.4,13.1,19.4z"/>
            <path class="gjs-block-svg-path" d="M23.9,11.7L19,3.2c-0.3-0.4-0.9-0.4-1.2,0l-1.1,1.9c-0.1,0.2-0.1,0.5,0,0.7l3.4,5.9c0.1,0.2,0.1,0.5,0,0.7
              l-4.1,7h0l-1.3,2.3c-0.3,0.4,0.1,1,0.6,1h2.2c0.2,0,0.5-0.1,0.6-0.3l5.8-10C24,12.1,24,11.9,23.9,11.7z"/>
          </svg>
        `
      }),
      category: 'Multimedia',
      content: { type: 'afrus-form' }
    }
  },
  {
    block: 'form',
    types: ['landing', 'thank_you_page'],
    opts: {
      label: setLabel({
        label: 'Form',
        icon: `
          <svg class="gjs-block-svg" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width: 40px;">
            <path class="gjs-block-svg-path" d="M22,5.5 C22,5.2 21.5,5 20.75,5 L3.25,5 C2.5,5 2,5.2 2,5.5 L2,8.5 C2,8.8 2.5,9 3.25,9 L20.75,9 C21.5,9 22,8.8 22,8.5 L22,5.5 Z M21,8 L3,8 L3,6 L21,6 L21,8 Z" fill-rule="nonzero"></path>
            <path class="gjs-block-svg-path" d="M22,10.5 C22,10.2 21.5,10 20.75,10 L3.25,10 C2.5,10 2,10.2 2,10.5 L2,13.5 C2,13.8 2.5,14 3.25,14 L20.75,14 C21.5,14 22,13.8 22,13.5 L22,10.5 Z M21,13 L3,13 L3,11 L21,11 L21,13 Z" fill-rule="nonzero"></path>
            <rect class="gjs-block-svg-path" x="2" y="15" width="10" height="3" rx="0.5"></rect>
          </svg>
        `
      }),
      category: 'Forms',
      content: `
        <form id="form" class="form card elevation-2 container container--fluid">
          <div class="row">
            <div class="col col-12" attr-xs="12">
              <label id="label" class="label">Name</label>
              <input placeholder="Type here your name" class="input"/>
            </div>
            <div class="col col-12" attr-xs="12">
              <label id="label" class="label">Email</label>
              <input type="email" placeholder="Type here your email" class="input"/>
            </div>
            <div class="col col-12" attr-xs="12">
              <label id="label" class="label">Message</label>
              <textarea class="textarea input" placeholder="Type here your message"></textarea>
            </div>
            <div class="col col-12 d-flex justify-end" attr-xs="12">
              <button type="submit" class="button size--default" attr-size="default">
                <span>Send</span>
              </button>
            </div>
          <div>
        </form>
      `
    }
  },
  {
    block: 'input',
    types: ['landing', 'thank_you_page'],
    opts: {
      label: setLabel({
        label: 'Input',
        icon: `
          <svg class="gjs-block-svg" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width: 40px;">
            <path class="gjs-block-svg-path" d="M22,9 C22,8.4 21.5,8 20.75,8 L3.25,8 C2.5,8 2,8.4 2,9 L2,15 C2,15.6 2.5,16 3.25,16 L20.75,16 C21.5,16 22,15.6 22,15 L22,9 Z M21,15 L3,15 L3,9 L21,9 L21,15 Z"></path>
            <polygon class="gjs-block-svg-path" points="4 10 5 10 5 14 4 14"></polygon>
          </svg>
        `
      }),
      category: 'Forms',
      content: { type: 'input' }
    }
  },
  {
    block: 'textarea',
    types: ['landing', 'thank_you_page'],
    opts: {
      label: setLabel({
        label: 'textarea',
        icon: `
          <svg class="gjs-block-svg" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width: 40px;">
            <path class="gjs-block-svg-path" d="M22,7.5 C22,6.6 21.5,6 20.75,6 L3.25,6 C2.5,6 2,6.6 2,7.5 L2,16.5 C2,17.4 2.5,18 3.25,18 L20.75,18 C21.5,18 22,17.4 22,16.5 L22,7.5 Z M21,17 L3,17 L3,7 L21,7 L21,17 Z"></path>
            <polygon class="gjs-block-svg-path" points="4 8 5 8 5 12 4 12"></polygon>
            <polygon class="gjs-block-svg-path" points="19 7 20 7 20 17 19 17"></polygon>
            <polygon class="gjs-block-svg-path" points="20 8 21 8 21 9 20 9"></polygon>
            <polygon class="gjs-block-svg-path" points="20 15 21 15 21 16 20 16"></polygon>
          </svg>
        `
      }),
      category: 'Forms',
      content: '<textarea class="textarea input"></textarea>'
    }
  },
  {
    block: 'select',
    types: ['landing', 'thank_you_page'],
    opts: {
      label: setLabel({
        label: 'Select',
        icon: `
          <svg class="gjs-block-svg" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width: 40px;">
            <path class="gjs-block-svg-path" d="M22,9 C22,8.4 21.5,8 20.75,8 L3.25,8 C2.5,8 2,8.4 2,9 L2,15 C2,15.6 2.5,16 3.25,16 L20.75,16 C21.5,16 22,15.6 22,15 L22,9 Z M21,15 L3,15 L3,9 L21,9 L21,15 Z" fill-rule="nonzero"></path>
            <polygon class="gjs-block-svg-path" transform="translate(18.500000, 12.000000) scale(1, -1) translate(-18.500000, -12.000000) " points="18.5 11 20 13 17 13"></polygon>
            <rect class="gjs-block-svg-path" x="4" y="11.5" width="11" height="1"></rect>
          </svg>
        `
      }),
      category: 'Forms',
      content: `
        <select class="select input">
          <option value="">Seleccione una opción</option>
          <option value="1">Option 1</option>
        </select>
      `
    }
  },
  {
    block: 'button-form',
    types: ['landing', 'thank_you_page'],
    opts: {
      label: setLabel({
        label: 'Button form',
        icon: `
          <svg class="gjs-block-svg" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width: 40px;">
            <path class="gjs-block-svg-path" d="M22,9 C22,8.4 21.5,8 20.75,8 L3.25,8 C2.5,8 2,8.4 2,9 L2,15 C2,15.6 2.5,16 3.25,16 L20.75,16 C21.5,16 22,15.6 22,15 L22,9 Z M21,15 L3,15 L3,9 L21,9 L21,15 Z" fill-rule="nonzero"></path>
            <rect class="gjs-block-svg-path" x="4" y="11.5" width="16" height="1"></rect>
          </svg>
        `
      }),
      category: 'Forms',
      content: `
      <button type="submit" class="button size--default">
        <span>Button</span
      </button>`
    }
  },
  {
    block: 'label',
    types: ['landing', 'thank_you_page'],
    opts: {
      label: setLabel({
        label: 'Label',
        icon: 'label'
      }),
      category: 'Forms',
      content: '<label id="label">Label</label>'
    }
  },
  {
    block: 'checkbox',
    types: ['landing', 'thank_you_page'],
    opts: {
      label: setLabel({ label: 'Checkbox', icon: 'check_box' }),
      category: 'Forms',
      content: `<div class="d-flex align-center">
          <input type="checkbox" id="checkbox" />
          <label id="label" for="checkbox" class="label label--inline">My checkbox</label>
        </div>`
    }
  },
  {
    block: 'radio',
    types: ['landing', 'thank_you_page'],
    opts: {
      label: setLabel({ label: 'Radio', icon: 'radio_button_checked' }),
      category: 'Forms',
      content: `<div class="d-flex align-center">
        <input type="radio" id="radio" />
        <label id="label" for="radio" class="label label--inline">My radio</label>
      </div>`
    }
  }
]

export default BlockManager
